// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__tTzLj","root":"Logo_root__FZTEU","vertical-timeline-element-icon":"Logo_vertical-timeline-element-icon__j0+jz"};